import { ResetAction, SetValueAction } from 'ngrx-forms';

// IMPORTANT Autogenerated file
import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import * as AuthActions from './auth.actions';
import { LOGIN_FORM_ID, loginFormInitialState, LoginFormValue } from './auth.reducer';
import * as AuthSelectors from './auth.selectors';

@Injectable()
export class AuthFacade {
  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  selectLoggedUser$ = this.store.pipe(select(AuthSelectors.selectLoggedUser));
  error$ = this.store.pipe(select(AuthSelectors.selectAuthError));

  selectLoginForm$ = this.store.pipe(select(AuthSelectors.selectLoginForm));
  selectAuthError$ = this.store.pipe(select(AuthSelectors.selectAuthError));
  resetPasswordEmailSent$ = this.store.pipe(
    select(AuthSelectors.resetPasswordEmailSent)
  );

  selectUserMustResetPassword$ = this.store.pipe(
    select(AuthSelectors.selectUserMustResetPassword)
  );
  selectForgotPasswordForm$ = this.store.pipe(
    select(AuthSelectors.selectForgotPasswordForm)
  );
  selectResetPasswordForm$ = this.store.pipe(
    select(AuthSelectors.selectResetPasswordForm)
  );
  seletQueryParams$ = this.store.pipe(select(AuthSelectors.selectQueryParams));

  constructor(private store: Store) {}

  loginAAD(rememberMe: boolean) {
    this.store.dispatch(AuthActions.loginWithAAD({ rememberMe }));
  }

  login(
    username: string,
    password: string,
    rememberMe: boolean,
    newPassword: string
  ) {
    this.store.dispatch(
      AuthActions.login({ username, password, rememberMe, newPassword })
    );
  }

  forceRefresh() {
    this.store.dispatch(AuthActions.forceRefresh());
  }

  logout() {
    this.store.dispatch(AuthActions.logout());
  }

  checkAADAuth() {
    this.store.dispatch(AuthActions.checkAADAuth());
  }

  getLoggedUser() {
    this.store.dispatch(AuthActions.getLoggedUser());
  }

  sessionExpired() {
    this.store.dispatch(AuthActions.sessionExpired());
  }

  loginFormInitialize() {
    this.store.dispatch(
      new SetValueAction<LoginFormValue>(LOGIN_FORM_ID, loginFormInitialState)
    );
    this.store.dispatch(new ResetAction(LOGIN_FORM_ID));
  }

  loginFormInitializeWithTmpPassword(username: string, password: string) {
    this.store.dispatch(
      new SetValueAction<LoginFormValue>(LOGIN_FORM_ID, {
        username,
        password,
        rememberMe: false,
        newPassword: '',
        confirmPassword: '',
      })
    );
    this.store.dispatch(new ResetAction(LOGIN_FORM_ID));
  }

  forgotPassword(username: string) {
    this.store.dispatch(AuthActions.forgotPassword({ username }));
  }

  resetPassword(token: string, newPassword: string) {
    this.store.dispatch(AuthActions.resetPassword({ token, newPassword }));
  }

  resetAuthError() {
    this.store.dispatch(AuthActions.resetAuthError());
  }
}
